import { IReduxBaseAction } from '@mihanizm56/redux-core-modules';

const CREATE_SUPPLY_ACTION_SAGA = 'supplies-managment-front_create-supply-module_CREATE_SUPPLY_ACTION_SAGA';
export const createSupplyActionSaga: IReduxBaseAction<
  typeof CREATE_SUPPLY_ACTION_SAGA
> = () => ({
  type: CREATE_SUPPLY_ACTION_SAGA,
});
createSupplyActionSaga.type = CREATE_SUPPLY_ACTION_SAGA;
